"use client";

import React from "react";
import { Handshake, Landmark, ChartLine } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseAreas = [{
  title: "Managed IT Support",
  description: "Comprehensive Annual Maintenance Contracts (AMC) providing 24/7 peace of mind. We architect resilient systems that scale with your enterprise ambition.",
  icon: Handshake
}, {
  title: "Networking & Infrastructure",
  description: "Design and deployment of high-performance networks tailored for high-demand environments, ensuring seamless connectivity across your digital landscape.",
  icon: Landmark
}, {
  title: "Data Protection & Cloud",
  description: "Multi-tier backup solutions and gold-standard cybersecurity to ensure business continuity, zero data loss, and an untouchable digital reputation.",
  icon: ChartLine
}];
export default function AreasOfExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222090" id="infrastructure-pillars" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-30"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/10 rounded-lg blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-6 md:px-8 max-w-7xl relative z-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-sm font-bold tracking-widest text-primary uppercase mb-4 font-mono">
            Core Competencies
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold font-default text-foreground leading-tight tracking-tighter">
            Infrastructure Pillars
          </h3>
          <p className="mt-6 text-lg text-muted-foreground font-default leading-relaxed">
            Precision technology and proven excellence since 2014. We bridge the gap between complex technology and business efficiency with architected resilience.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {expertiseAreas.map((area, i) => <Card key={i} data-index={i} className={`group p-10 bg-card/40 backdrop-blur-sm border border-border/60 hover:border-primary shadow-md hover:shadow-primary/10 transition-all duration-500 ease-out flex flex-col h-full transform relative overflow-hidden ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              {}
              <span className="absolute -right-4 -top-4 text-8xl font-bold text-foreground/5 pointer-events-none font-mono group-hover:text-primary/10 transition-colors duration-500">
                0{i + 1}
              </span>

              <CardHeader className="p-0 mb-8">
                <div className="w-16 h-16 rounded-md bg-muted/50 flex items-center justify-center mb-8 border border-border transition-colors duration-300 group-hover:bg-primary/10 group-hover:border-primary/40">
                  <area.icon className="w-8 h-8 text-primary transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-2xl font-bold font-default text-foreground group-hover:text-primary transition-colors duration-300">
                  {area.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0 flex-grow">
                <p className="text-muted-foreground font-default leading-relaxed text-base">
                  {area.description}
                </p>
              </CardContent>
              
              {}
              <div className="absolute top-0 left-0 w-full h-1 bg-primary/20 -translate-y-full group-hover:animate-[scanline_2s_linear_infinite] pointer-events-none"></div>
              
              {}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full"></div>
            </Card>)}
        </div>
      </div>
    </section>;
}